/**
 * Short labels for the sector names mm-be sends. The API has no short form of
 * its own, and the grids that print sectors as row or column heads (Broker by
 * sector, the Signal Zone cycle map) have a narrow box for each, so this is
 * the one place a sector name is abbreviated. Every caller keeps the full name
 * in the head's `title` and accessible name. A sector not listed here prints
 * in full rather than as a guess.
 */
const SHORT_SECTOR_LABEL: Readonly<Record<string, string>> = {
  'Commercial Banks': 'Banks',
  'Development Banks': 'Dev banks',
  'Manufacturing and Processing': 'Manufacturing',
  'Life Insurance': 'Life ins.',
  'Non-Life Insurance': 'Non-life ins.',
  'Hotels and Tourism': 'Hotels',
  'Corporate Debenture': 'Debentures',
}

export const shortSectorLabel = (name: string): string => SHORT_SECTOR_LABEL[name] ?? name
